import React from "react";
import app from "../../assets/app-store.png";
import play from "../../assets/play-store.png";
import banner from "../../assets/mobile-slide-view.webp";

const Banner = () => {
  return (
    <div className="bg-[#F8FCFA] flex flex-col justify-center items-center  py-16 md:pt-28 md:pb-10">
      <div className="w-full px-6 xl:px-0 xl:w-2xl">
        <div className="bg-[#16A951] rounded-2xl z-0">
          <div className="flex flex-col items-center md:px-16 lg:px-32 xl:px-60 pt-14 text-white px-4">
            <div className="font-bold text-3xl sm:text-4xl text-center mb-2 md:mb-4">
              Get the App
            </div>{" "}
            <div className="font-lexend-deca font-normal text-xs sm:text-lg text-white text-center mb-4 max-w-xl">
              Download to explore and connect with your desired entities
              effortlessly.
            </div>
            <div className="flex gap-2 sm:gap-4  md:flex-row justify-center items-center pb-8 md:pb-32">
              <div className=" ">
                <a
                  href="https://apps.apple.com/sb/app/kaha-app/id6470139955"
                  target="_blank"
                >
                  <img src={app} alt="App Store" />
                </a>
              </div>
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=com.kaha_hits.kaha"
                  target="_blank"
                >
                  <img src={play} alt="Play Store" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center sm:justify-start ml-0 sm:ml-[1%] lg:ml-[15%] md:-mt-20 z-10">
          <img src={banner} alt="Mobile Slide View" loading="lazy" className="w-auto h-auto max-w-full" />
        </div>
      </div>
    </div>
  );
};

export default Banner;
